<mat-card>
  <mat-card-header>
    <mat-card-title>
      <h2>{{ 'dataManagement.versions.title' | transloco }}</h2>
    </mat-card-title>
  </mat-card-header>
  <div class="outer-container">
    <div class="multiline"> {{'dataManagement.versions.securityDisclaimerPre'|transloco}}
      <a [href]="getEmailText('contactInfo.emailSupport')"> {{'contactInfo.emailSupport'| transloco}}</a>
      {{'dataManagement.versions.securityDisclaimerPost'|transloco}}
    </div>
  </div>
</mat-card>
